import { FinancialCompany } from "@interfaces/MarketPlace";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface InterfaceOffers {
  loan_application_id: string;
  loan_amount: number;
  term: number;
  interest_rate: number;
  opening_fee: number;
  monthly_amount: number | null;
  days_validity: number;
  accept: boolean | null;
  declined: boolean;
  financial_company_id: string;
  id: string;
  financial_company: FinancialCompany;
}

export interface AppSlice {
  offers: InterfaceOffers;
}

const initialState: AppSlice = {
  offers: {
    id: "",
    loan_application_id: "",
    loan_amount: 0,
    term: 0,
    interest_rate: 0,
    opening_fee: 0,
    monthly_amount: 0,
    days_validity: 0,
    accept: false,
    declined: false,
    financial_company: {
      code: "",
      description: "",
      logo: "",
      name: "",
      company_id: null,
      company: null,
      is_partner: false,
    },
    financial_company_id: "",
  },
};

export const marketPlaceSlice = createSlice({
  name: "marketPalce",
  initialState,
  reducers: {
    setSelectedOffer: (state, action: PayloadAction<InterfaceOffers>) => {
      state.offers = action.payload;
    },
  },
});

export const { setSelectedOffer } = marketPlaceSlice.actions;

export default marketPlaceSlice.reducer;
